import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { ICON_ALIASES } from '_constants/icons';
import { theme } from '_constants/theme';

import Icon from 'components/atomic/Icon';
import Popup from 'components/atomic/Popup';
import Text from 'components/atomic/layouts/Text';

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${theme.spaces.smallX}px;
  position: relative;
  padding-top: ${theme.spaces.small2X}px;
  padding-bottom: ${theme.spaces.small2X}px;
  padding-left: ${theme.spaces.smallX}px;
  padding-right: ${theme.spaces.smallX}px;
  background: transparent;
`;

const StyledIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const StyledMessageContainer = styled.div`
  padding: ${theme.spaces.smallX}px;
`;

const CheckListItem = ({ title, hint, completed }) => {
  return (
    <StyledContainer>
      <Popup
        show={completed || !hint ? false : undefined}
        trigger={
          <StyledIconContainer>
            <Icon
              alias={completed ? ICON_ALIASES.tickCircleFilled : ICON_ALIASES.infoCircle}
              color={completed ? theme.colors.indigo.primary : theme.colors.gray.secondary}
            />
          </StyledIconContainer>
        }
      >
        <StyledMessageContainer>
          <Text size={theme.fontSizes.smallX} weight={400} color={theme.colors.gray.primary}>
            {hint}
          </Text>
        </StyledMessageContainer>
      </Popup>
      <Text
        size={theme.fontSizes.small}
        weight={500}
        lineHeight={theme.spaces.large}
        color={completed ? theme.colors.indigo.primary : theme.colors.gray.secondary}
      >
        {title}
      </Text>
    </StyledContainer>
  );
};

CheckListItem.propTypes = {
  title: PropTypes.string,
  hint: PropTypes.node,
  completed: PropTypes.bool,
};

export default CheckListItem;
